import { render, staticRenderFns } from "./Eheader.vue?vue&type=template&id=272fa0ac&scoped=true"
import script from "./Eheader.vue?vue&type=script&lang=js"
export * from "./Eheader.vue?vue&type=script&lang=js"
import style0 from "./Eheader.vue?vue&type=style&index=0&id=272fa0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272fa0ac",
  null
  
)

export default component.exports